import { render, staticRenderFns } from "./Card-Promotion.vue?vue&type=template&id=737e7437&"
import script from "./Card-Promotion.vue?vue&type=script&lang=js&"
export * from "./Card-Promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports